import invoiceInstance from './instance'

const getInvoice = (invoiceUuid) => {
	return invoiceInstance.get(`/invoices/${invoiceUuid}`)
}

export const fetchOrderInvoices = (orderId) => invoiceInstance.get(`/invoices?orderId=${orderId}`)

export default getInvoice
